import { MotionDiv } from '@lib/motion';
import { Button } from '@ui/Button/Button';
import IconType from '@ui/Icon/StaticIcon/IconType';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import Text, { TextVariant } from '@ui/Text/Text';
import cn from '@utils/cn';
import { SelectProps } from './Select';

type SelectMobileProps = SelectProps & {
  itemClick: (val: string | number) => void;
  close: () => void;
  setSearch: (val: string) => void;
  search: string;
  showSearch?: boolean;
};

export default function SelectMobile({
  label,
  items,
  setSelectedItems,
  selectedItems,
  itemClick,
  close,
  setSearch,
  search,
  showSearch,
  isMultiple,
}: SelectMobileProps) {
  return (
    <div className="fixed left-0 top-0 z-20 flex h-full w-full items-end justify-center ">
      <MotionDiv
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.25 }}
        exit={{ opacity: 0 }}
        className="absolute left-0 top-0 h-full w-full bg-black"
        onClick={close}
      ></MotionDiv>
      <MotionDiv
        initial={{ bottom: '-30%' }}
        animate={{ bottom: 0 }}
        exit={{ bottom: '-30%' }}
        className="absolute left-0 z-20 w-full rounded-t-lg bg-white"
      >
        <div className="flex flex-col items-center gap-2 border-b px-2 pb-3 pt-2">
          <div className="h-1 w-[45px] cursor-pointer rounded-2xl bg-black opacity-10" onClick={close} />
          <Text content={label} variant={TextVariant.TextLabel} />
        </div>

        <div className="border-y py-1">
          {showSearch && (
            <div className="w-full px-1 pb-1">
              <input
                className={cn(
                  'font-the-future font-regular w-full rounded-sm border bg-transparent p-1',
                  'text-description-sm md:text-description-lg text-body-foreground outline-none',
                )}
                onChange={(val) => {
                  setSearch(val.target.value);
                }}
                value={search}
              ></input>
            </div>
          )}
          <div className="flex max-h-[300px] select-none flex-col gap-1 overflow-auto px-2  ">
            {items.map((item) => (
              <div
                key={item.value}
                onClick={() => itemClick(item.value)}
                className={cn(
                  'group flex w-full cursor-pointer  gap-4 px-2 py-1.5',
                  'hover:bg-input items-center justify-between rounded-lg',
                  {
                    'bg-background': selectedItems?.includes(item.value) && !isMultiple,
                  },
                )}
              >
                <div className="flex items-center gap-1.5">
                  {isMultiple && (
                    <StaticIcon
                      icon={selectedItems?.includes(item.value) ? IconType.checkBoxSelected : IconType.checkBox}
                      className={cn('fill-secondary', {
                        'fill-link': selectedItems?.includes(item.value),
                      })}
                    />
                  )}
                  <Text content={item.label} variant={TextVariant.TextLabel} />
                </div>
                <Text
                  content={item.hint}
                  className="hidden select-none capitalize group-hover:block"
                  variant={TextVariant.TextDescription}
                />
              </div>
            ))}
          </div>
        </div>
        {isMultiple && (
          <div className="flex gap-4 p-4">
            <Button
              size="l"
              variant="outline"
              className="grow select-none capitalize"
              onClick={() => {
                setSelectedItems?.([]);
                close();
              }}
            >
              Clear {selectedItems?.length ? `(${selectedItems?.length})` : ''}
            </Button>
            <Button size="l" className="grow select-none capitalize" variant="primary" onClick={close}>
              Apply
            </Button>
          </div>
        )}
      </MotionDiv>
    </div>
  );
}
